import axios from "axios";
import fileDownload from "js-file-download";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllContracts = async (params: any) => {
  const url = endpoints.BASE_API + "contract";
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });
  return response;
};

const getContractById = async (id: number) => {
  const url = endpoints.BASE_API + "contract/" + id;
  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const deleteContract = async (id: number) => {
  const url = endpoints.BASE_API + "contract/" + id;
  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const createContract = async (params: any) => {
  const url = endpoints.BASE_API + "contract";
  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const updateContract = async (params: any) => {
  const url = endpoints.BASE_API + "contract/" + params.get("id");
  const { data: response } = await axios.patch(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const downloadPDF = async (params: any) => {
  const url = endpoints.BASE_API + "download";
  await axios.post(url, { pathName: params }, {
    headers: {
      Authorization: accessToken,
      ContentType:
        "application/pdf",
    },
    responseType: "blob",
  }).then((res) => {
    var blob = new Blob([res.data], {
      type: "application/pdf",
    });
    fileDownload(blob, `${params.split("/")[4]}`);
  })
};

const sendFile = async (id: any) => {
  const url = endpoints.BASE_API + `contract/share/${id}`;
  const { data: response } = await axios.post(url, {}, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response;
};

const contractService = {
  getAllContracts,
  getContractById,
  createContract,
  updateContract,
  deleteContract,
  downloadPDF,
  sendFile,
};

export default contractService;
